<template>
  <div class="content md no-padding flex-box vertical">
    <RoleForm ref="addForm" :initial="initial" class="add-form-box"></RoleForm>
    <a-space class="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleConfirm">保存</a-button>
    </a-space>
  </div>
</template>

<script>
import RoleForm from "./components/RoleForm.vue";

export default {
  name: "ActivityAdd",
  components: {
    RoleForm,
  },
  data() {
    return {
      initial: null,
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
  },
  methods: {
    handleCancel() {
      this.$router.back();
    },
    handleConfirm() {
      this.$refs.addForm.validate().then((form) => {
        this.$axios({
          url: "/admin/data-role",
          method: "POST",
          data: form,
          noTempleFilter: true,
        }).then(() => {
          this.$message.success("添加成功");
          this.$router.back();
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-form-box {
  flex-direction: column;
}
.footer {
  width: 100%;
}
</style>
